<template>
  <chart-box @screen.once="showElement"
              title="Painel de Entregas de Cartas"
              :isTitleCenter="true">
    <v-layout row wrap>
      <loading v-if="loading > 0" class="absolute-center" />

      <v-flex v-else md12 class="widget-legend px-5 py-4">
        <div v-if="hasData">
          <apexcharts class="legend-multiple-lines"
                      width="100%"
                      height=130
                      type="bar"
                      :options="options"
                      :series="options.series" />

          <v-layout class="extra-info" row wrap justify-end>
            <v-flex class="pt-0" xs12 sm6 text-xs-center text-sm-right>
              <div class="headline">{{ options.totalValue }}</div>
              <div class="subheading">Total (Cartas Postadas)</div>
            </v-flex>
          </v-layout>
        </div>
        <empty-state v-else
                     size="75px"
                     class="fixed-center">
          No momento não há dados
        </empty-state>
      </v-flex>
    </v-layout>
  </chart-box>
</template>

<script>
  import chartMixin from '@/mixins/chart'
  import ChartBox from './ChartBox'
  import Loading from '@/components/ui/Loading'
  import EmptyState from '@/components/ui/EmptyState'

  export default {
    components: { ChartBox, Loading, EmptyState },
    mixins: [ chartMixin ],
    data () {
      return {
        loading: 0,
        hasData: false,
        options: {
          series: [
            { name: 'Efetivadas', data: [0] },
            { name: 'Falhas', data: [0] },
            { name: 'Em Andamento', data: [0] }
          ],
          totalValue: 3427,
          chart: {
            stacked: true,
            stackType: '100%',
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              barHeight: 70,
              horizontal: true,
              dataLabels: { hideOverflowingLabels: false }
            }
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          title: { text: undefined },
          xaxis: {
            categories: ['Painel de Entregas de Cartas'],
            labels: { show: false },
            axisBorder: { show: false }
          },
          yaxis: {
            title: { text: undefined },
            labels: { show: false },
            axisBorder: { show: false }
          },
          grid: {
            show: false,
            padding: { top: -20, right: 0, bottom: -60, left: 0 }
          },
          fill: { opacity: 1 },
          dataLabels: {
            style: { fontSize: '14px' },
            dropShadow: {
              enabled: true,
              top: 1,
              left: 1,
              blur: 1,
              opacity: 0.25
            }
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: -30,
            offsetY: 0,
            fontSize: '14px',
            markers: { radius: 15 },
            itemMargin: { vertical: 0, horizontal: 0 },
            formatter: (status, chart) => {
              const value = chart.w.globals.series[chart.seriesIndex]

              return `${status}<br><strong>${value}</strong>`
            }
          },
          tooltip: {
            enabled: false
          },
          colors: [
            this.$vuetify.theme.primary,
            this.$vuetify.theme.accent,
            this.$vuetify.theme.secondary
          ],
          responsive: [{
            breakpoint: 599,
            options: {
              chart: { height: 200 },
              legend: {
                fontSize: '12px',
                itemMargin: { vertical: 5, horizontal: 5 }
              }
            }
          }]
        }
      }
    }
  }
</script>
